export default __webpack_public_path__ + "static/solutions-link-icon4.url-d73b8e696f323406750a41eb6746b7eb.svg";